import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { InitiatorType } from '@wix/ambassador-asa-preferences-v1-guidelines/types';
import { isValidGuidelines } from '../../entities';
import { pagingMetadataToCursorResponse } from '../../utils';
import { BaseClient } from '../BaseClient';
export class GuidelinesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createGuidelinesImpl", void 0);
    _defineProperty(this, "getGuidelinesImpl", void 0);
    _defineProperty(this, "updateGuidelinesImpl", void 0);
    _defineProperty(this, "deleteGuidelinesImpl", void 0);
    _defineProperty(this, "queryGuidelinesImpl", void 0);
  }
  async createGuidelines(newGuidelines) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        guidelines
      } = await this.request(this.createGuidelinesImpl({
        guidelines: newGuidelines
      }), ...args);
      return this.convertToEntity(guidelines);
    } catch (error) {
      this.logError('createGuidelines', 'Failed to create guidelines', {
        newGuidelines
      }, error);
      throw error;
    }
  }
  async getGuidelines(guidelinesId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        guidelines
      } = await this.request(this.getGuidelinesImpl({
        guidelinesId
      }), ...args);
      return this.convertToEntity(guidelines);
    } catch (error) {
      this.logError('getGuidelines', 'Failed to get guidelines', {
        guidelinesId
      }, error);
      throw error;
    }
  }
  async updateGuidelines(guidelinesData) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      const {
        guidelines: updatedGuidelines
      } = await this.request(this.updateGuidelinesImpl({
        guidelines: guidelinesData,
        fieldMask: ['guidelines']
      }), ...args);
      return this.convertToEntity(updatedGuidelines);
    } catch (error) {
      this.logError('updateGuidelines', 'Failed to update guidelines', {
        guidelinesData
      }, error);
      throw error;
    }
  }
  async updateGuidelinesAutoRecurring(guideline) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      const {
        guidelines: updatedGuidelines
      } = await this.request(this.updateGuidelinesImpl({
        guidelines: {
          id: guideline.id,
          revision: guideline.revision,
          initiatorType: InitiatorType.SERVICE,
          serviceDetails: {
            autoRecurring: guideline.autoRecurring
          }
        },
        fieldMask: ['serviceDetails.autoRecurring']
      }), ...args);
      return this.convertToEntity(updatedGuidelines);
    } catch (error) {
      this.logError('updateGuidelinesAutoRecurring', 'Failed to update guidelines auto recurring', {
        guideline
      }, error);
      throw error;
    }
  }
  async deleteGuidelines(guidelinesId) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      await this.request(this.deleteGuidelinesImpl({
        guidelinesId
      }), ...args);
    } catch (error) {
      this.logError('deleteGuidelines', 'Failed to delete guidelines', {
        guidelinesId
      }, error);
      throw error;
    }
  }
  async queryGuidelines(query) {
    try {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      const {
        guidelines,
        pagingMetadata
      } = await this.request(this.queryGuidelinesImpl({
        query
      }), ...args);
      if (!guidelines) {
        throw new Error('Received invalid guidelines');
      }
      return {
        items: guidelines.map(this.convertToEntity),
        ...pagingMetadataToCursorResponse(pagingMetadata)
      };
    } catch (error) {
      this.logError('queryGuidelines', 'Failed to query guidelines', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(guidelines) {
    try {
      if (!guidelines) {
        throw new Error('Invalid guidelines');
      }
      const convertedGuidelines = {
        id: guidelines.id,
        revision: guidelines.revision,
        guidelines: guidelines.guidelines,
        initiatorId: guidelines.initiatorId,
        initiatorType: guidelines.initiatorType,
        ...(guidelines.serviceDetails && {
          serviceDetails: {
            autoRecurring: guidelines.serviceDetails.autoRecurring
          }
        })
      };
      if (isValidGuidelines(convertedGuidelines)) {
        return convertedGuidelines;
      }
      throw new Error('Invalid guidelines data');
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert guidelines', {
        guidelines
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'GuidelinesClient';
  }
}
//# sourceMappingURL=GuidelinesClientBase.js.map